var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankingandfinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04651 15C2.5107 15 1 13.4893 1 9.95349V6.04651C1 2.5107 2.5107 1 6.04651 1H9.95349C13.4893 1 15 2.5107 15 6.04651V9.95349C15 13.4893 13.4893 15 9.95349 15H6.04651ZM1.97674 6.04651V9.95349C1.97674 12.9553 3.04465 14.0233 6.04651 14.0233H9.95349C12.9553 14.0233 14.0233 12.9553 14.0233 9.95349V6.04651C14.0233 3.04465 12.9553 1.97674 9.95349 1.97674H6.04651C3.04465 1.97674 1.97674 3.04465 1.97674 6.04651Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78467 6.60162H8.9277C8.87878 6.12506 8.62405 5.68254 8.25123 5.41022H9.78467C9.87745 5.41022 9.95336 5.33363 9.95336 5.24002C9.95336 5.14641 9.87745 5.06982 9.78467 5.06982H6.21508C6.1223 5.06982 6.04639 5.14641 6.04639 5.24002C6.04639 5.33363 6.1223 5.41022 6.21508 5.41022H7.23737C7.9324 5.41022 8.50596 5.93784 8.58862 6.60162H6.21508C6.1223 6.60162 6.04639 6.67821 6.04639 6.77182C6.04639 6.86543 6.1223 6.94202 6.21508 6.94202H8.58862C8.50427 7.63133 7.92396 8.14873 7.23737 8.15043H6.21677C6.1223 8.15214 6.04639 8.23043 6.04807 8.32574C6.04807 8.37169 6.06832 8.41595 6.10037 8.44828L8.65272 10.8838C8.7202 10.9485 8.82648 10.9451 8.89058 10.877C8.95469 10.8072 8.95132 10.7 8.88384 10.6336L6.63851 8.49083H7.23569C8.11627 8.49083 8.84335 7.81003 8.9277 6.94202H9.78467C9.87745 6.94202 9.95336 6.86543 9.95336 6.77182C9.95336 6.67821 9.87745 6.60162 9.78467 6.60162Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.523404
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingandfinance);
export default __webpack_public_path__ + "static/media/banking and finance.8c6e1a4b7bfafb4215ff5dcf4d2d01ab.svg";
export { ForwardRef as ReactComponent };